import { t } from "./i18n.js";

export function escapeHtml(text: string): string {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}

export function formatAction(action: string): string {
  const keyMap: Record<string, string> = {
    login: "action_authentication",
    payment: "action_payment",
    signing: "action_signing",
  };
  const key = keyMap[action];
  return key ? t(key) : action;
}

export function formatFlow(flowType: string): string {
  const keyMap: Record<string, string> = {
    authorization: "flow_authorization",
    app2app: "flow_app2app",
    iframe: "flow_iframe",
    ciba: "flow_ciba",
    signup: "flow_signup",
  };
  const key = keyMap[flowType];
  return key ? t(key) : flowType;
}

export function formatAmr(amr: string): string {
  const keyMap: Record<string, string> = {
    "bis-mfa": "amr_bis_mfa",
    "bis-hwk": "amr_bis_hwk",
    "bis-bim": "amr_bis_bim",
    "bis-bid": "amr_bis_bid",
    "bis-otp": "amr_bis_otp",
  };
  const key = keyMap[amr];
  return key ? t(key) : amr;
}

export function formatStatus(status: string): string | null {
  const keyMap: Record<string, string> = {
    failed: "status_failed",
    abandoned: "status_abandoned",
  };
  const key = keyMap[status];
  return key ? t(key) : null;
}

export function formatRelativeTime(isoString: string): string {
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) {
    return "\u2014";
  }
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMins < 1) return t("time_now");
  if (diffMins < 60) return t("time_min_ago", { n: diffMins });
  if (diffHours < 24) {
    return diffHours === 1
      ? t("time_hour_ago", { n: diffHours })
      : t("time_hours_ago", { n: diffHours });
  }
  if (diffDays === 1) return t("time_yesterday");
  if (diffDays < 7) return t("time_days_ago", { n: diffDays });

  const day = date.getDate();
  const month = date.toLocaleDateString(document.documentElement.lang, {
    month: "short",
  });
  const year = date.getFullYear();
  const currentYear = now.getFullYear();

  return year === currentYear ? `${day}. ${month}` : `${day}. ${month} ${year}`;
}

export function formatAbsoluteDate(isoString: string): string {
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return "\u2014";
  return date.toLocaleString(document.documentElement.lang, {
    dateStyle: "long",
    timeStyle: "short",
  });
}

export function formatShortDate(isoString: string): string {
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return "\u2014";
  return date.toLocaleDateString(document.documentElement.lang, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

/** Extract values for a specific tag prefix from the tags array */
export function getTagValues(tags: string[], prefix: string): string[] {
  const p = `${prefix}:`;
  return tags.filter((t) => t.startsWith(p)).map((t) => t.slice(p.length));
}
